import React from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom'
import { Descriptions, Row, Col, Timeline } from 'antd';
import ClientServiceForm from './ClientServiceForm';
import { withTranslation } from 'react-i18next';

class ClientServiceView extends React.Component {
    state = {

    };

    componentDidMount() {
        let token = localStorage.getItem('token');
        axios.defaults.xsrfCookieName = 'csrftoken'
        axios.defaults.xsrfHeaderName = "X_CSRFTOKEN"
        axios.defaults.headers = {
            "Content-Type": "application/json",
            "Accept-Language": localStorage.getItem('language'),
            Authorization: `Token ${token}`,
        };
    }

    handleDownload(id, file_name) {
        axios({
            url: process.env.REACT_APP_AXIOS_URL + "/api/service/user/" + id + "/download/",
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            console.log(response);
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', file_name);
            document.body.appendChild(link);
            link.click();
        });
    }



    render() {
        const data = this.props.location.state.data;
        const { t } = this.props;

        return (
            <div>
                <Row>
                    <Descriptions title={t('clients.client_service.service_name', { service_name_display: data.service_name_display })} bordered>
                        <Descriptions.Item label={t('clients.client_service.website', "Website")}>{data.website}</Descriptions.Item>
                        <Descriptions.Item label={t('clients.client_service.status', "Status")}>{data.status_display}</Descriptions.Item>
                        <Descriptions.Item label={t('clients.client_service.monthly_price', "Monthly price")}>{data.monthly_price} €</Descriptions.Item>
                        <Descriptions.Item label={t('clients.client_service.start_date', "Start date")}>{data.start_date}</Descriptions.Item>
                        <Descriptions.Item label={t('clients.client_service.end_date', "End date")}>{data.end_date}</Descriptions.Item>
                        <Descriptions.Item label={t('clients.client_service.description', "Description")}>{data.description}</Descriptions.Item>
                        <Descriptions.Item label={t('clients.client_service.invoice', "Invoice")}>
                            {
                                data.invoice_file_name ?
                                    <a download target="_blank" href={data.invoice_file}>{t('clients.client_service.download', "Download")}</a> :
                                    t('clients.client_service.no_invoice', "No invoice for downloading")
                            }
                        </Descriptions.Item>
                    </Descriptions>
                </Row>
                <Row style={{ marginTop: 16 }}>
                    <Col span={12}>
                        <ClientServiceForm service_detail_id={data.id} />
                    </Col>
                    <Col span={12}>
                        {/* <Timeline >
                            <Timeline.Item color="green" label="2020-02-30">Create a service</Timeline.Item>
                            <Timeline.Item label="2020-03-12">Make modification</Timeline.Item>
                            <Timeline.Item label="2020-04-05">Ask a question</Timeline.Item>
                            <Timeline.Item color="red" label="2020-06-03">Complaint</Timeline.Item>
                        </Timeline> */}
                    </Col>
                </Row>

            </div>
        );
    }
}

export default withRouter(withTranslation()(ClientServiceView));


// WEBPACK FOOTER //
// ./src/containers/ClientZone/ClientServiceView.js